<div *ngIf='row' [routerLink]="['/messages', 'view', row.message_id, {
from: 'inbox'
}]" class='ListMessageMobileRow {{classes}}'>
  <div class='ListMessageMobileRow--left'>
    <div class='ListMessageMobileRow--left--contact'><span>{{ contact }}</span></div>
    <div class='ListMessageMobileRow--left--company'><span>{{ company }}</span></div>
    <div class='ListMessageMobileRow--left--subject text-muted'><span>{{ subject }}</span></div>
  </div>
  <div class='ListMessageMobileRow--right'>
    <div class='ListMessageMobileRow--right--date text-muted'>
      <span>{{ row.message_date | timezone: 'MM/DD/YYYY' }}</span></div>
    <div *ngIf='!isSingleUser' class='ListMessageMobileRow--right--representative text-muted'>
      <span>{{ representative }}</span></div>
  </div>
</div>